<template>
  <ForieLoader v-show="showLoader && this.$store.state.domainSystemX == 1" />
  <TeLoader v-show="showLoader && this.$store.state.domainSystemX == 2" />

  <div class="container mt-2">
    <div class="card bg-dark text-white">
      <div class="card-header">
        <div class="row">
          <div class="col-md-1">
            <country-flag class="me-0" :country="countryCode" size="big" />
          </div>
          <div class="col-md-11">
            <h4>
              {{ leadTitle }}
              <span style="font-size: 12px" class="float-end"
                ><i class="fa fa-eye"></i> {{ viewCount }}</span
              >
              <p class="float-end lead-time me-3">{{ createTime }}</p>
            </h4>

            <div class="lead-info mt-3 d-flex" v-if="loadDone">
              <div class="lead-type mt-2">
                <small :class="type == 0 ? 'buy' : 'sell'">
                  {{
                    type == 0
                      ? this.$store.getters.getWordLocale("txt_alim_talebi")
                      : type == 1
                      ? this.$store.getters.getWordLocale("txt_satis_teklifi")
                      : this.$store.getters.getWordLocale("txt_isbirligi")
                  }}
                </small>
              </div>
              <div class="separator"></div>
              <div v-if="credit > 0" class="lead-credit not-free">
                <i class="fas fa-coins"></i> {{ credit }}
              </div>
              <div v-else class="lead-credit free">
                <i class="fas fa-handshake"></i>
                {{ this.$store.getters.getWordLocale("txt_ucretsiz") }}
              </div>
              <div class="separator"></div>
              <div class="lead-country d-flex">
                <country-flag :country="countryCode" size="small" />
                <small>{{ countryName }}</small>
              </div>

              <div class="lead-status mt-1 ms-3">
                <span v-show="isLeadBought" class="bought-badge">
                  <i class="fas fa-handshake"></i> Bought</span
                >
                <span v-show="isLeadInBulletin" class="bought-badge">
                  <i class="fas fa-handshake"></i> Sent As Bulletin</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card bg-dark text-white mt-3">
      <div class="card-header">
        <b>{{ this.$store.getters.getWordLocale("txt_ozet") }}</b>
      </div>
      <div class="card-body">
        <p>{{ leadSummary }}</p>
      </div>
    </div>

    <div class="card bg-dark text-white mt-2">
      <div class="card-header">
        <b>{{ this.$store.getters.getWordLocale("txt_talep_bilgileri") }}</b>
      </div>
      <div v-show="isLoadingDone" class="card-body">
        <div
          v-if="!this.$store.state.userLoggedInX"
          class="alert text-center"
          role="alert"
        >
          <h4 class="alert-heading">
            <i class="fas fa-lock fa-2x text-danger"></i>
          </h4>
          <p>
            {{
              this.$store.getters.getWordLocale("txt_detay_icin_giris_yapin")
            }}
          </p>
          <hr />
          <p class="mb-0">
            <!-- <router-link
              class="btn btn-outline-success"
              :to="'/' + this.$store.state.langCodeX + '/login'"
              ><i class="fas fa-door-open"></i>
              {{ this.$store.getters.getWordLocale("txt_giris_yap") }}
            </router-link> -->
            <a
              class="btn btn-outline-success me-2"
              :href="
                this.$store.state.loginUrlX +
                '?apilogin=true&returnUrl=' +
                this.$store.state.currentUrlX
              "
              ><i class="fas fa-door-open"></i>
              {{ this.$store.getters.getWordLocale("txt_giris_yap") }}
            </a>
            <span class="ms-2 me-2">{{
              this.$store.getters.getWordLocale("txt_veya")
            }}</span>
            <a
              class="btn btn-outline-primary"
              :href="this.$store.state.signUpUrlX"
              target="_blank"
              ><i class="fas fa-user-plus"></i>
              {{ this.$store.getters.getWordLocale("txt_uye_ol") }}</a
            >
          </p>
        </div>
        <div class="row" v-show="canViewLead">
          <div class="col-12">
            <p style="white-space: pre-line">{{ leadMessage }}</p>
          </div>
          <div class="col-12 mt-2">
            <div class="card bg-dark text-white">
              <div class="card-header">
                <i class="fa fa-phone"></i>
                {{
                  this.$store.getters.getWordLocale("txt_iletisim_bilgileri")
                }}
              </div>

              <div class="body p-2 contact-details">
                <span
                  ><b>{{ this.$store.getters.getWordLocale("txt_ad_soyad") }}</b
                  >: <span>{{ nameSurname }}</span></span
                >
                <span
                  ><b>{{
                    this.$store.getters.getWordLocale("txt_firma_adi")
                  }}</b
                  >: <span>{{ companyName }}</span></span
                >
                <span
                  ><b>{{ this.$store.getters.getWordLocale("txt_adres") }}</b
                  >: <span>{{ address }}</span></span
                >
                <span
                  ><b>{{ this.$store.getters.getWordLocale("txt_fax") }}</b
                  >: <span>{{ fax }}</span></span
                >
                <span
                  ><b>{{ this.$store.getters.getWordLocale("txt_eposta") }}</b
                  >: <span>{{ email }}</span></span
                >
                <span
                  ><b>{{ this.$store.getters.getWordLocale("txt_ulke") }}</b
                  >:
                  <span>
                    <country-flag
                      class="me-0 country-flag"
                      :country="countryCode"
                      size="small"
                    />
                    {{ countryName }}</span
                  ></span
                >
                <span
                  ><b>{{
                    this.$store.getters.getWordLocale("txt_web_sitesi")
                  }}</b
                  >: <span>{{ webAddress }}</span></span
                >
                <span
                  ><b>{{ this.$store.getters.getWordLocale("txt_telefon") }}</b
                  >: <span>{{ phone }}</span></span
                >
              </div>
            </div>
          </div>

          <div v-show="leadDocuments.length > 0" class="col-12 mt-2">
            <div class="card bg-dark text-white">
              <div class="card-header">
                <i class="fa fa-file"></i>
                {{ this.$store.getters.getWordLocale("txt_dosya") }}
              </div>
              <div class="card-body">
                <div v-for="(doc, di) in leadDocuments" :key="di">
                  <a target="_blank" :href="doc.file">
                    <i class="fa fa-paperclip text-secondary"></i> {{ di + 1 }}.
                    {{ doc.name }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="row"
          v-show="
            canViewLead == false &&
            notFound == false &&
            this.$store.state.userLoggedInX == true
          "
        >
          <div class="buy-lead-info">
            <small
              ><img src="https://cdn.forie.com//storage/general/logo/lock.png"
            /></small>
          </div>

          <div
            v-show="credit > 0"
            class="select-company-to-proceed mt-2 text-center text-white"
          >
            <h3>
              {{
                this.$store.getters.getWordLocale("txt_kredi_gerektiren_talep")
              }}
            </h3>
            <h4>
              {{
                this.$store.getters.getWordLocale("txt_lead_kredi_harcamali")
              }}
            </h4>
          </div>

          <small class="auth-companies-title"
            ><i class="fas fa-exclamation-triangle"></i>
            {{
              this.$store.getters.getWordLocale(
                "txt_yetkilisi_oldugunuz_firmalar"
              )
            }}</small
          >

          <div
            v-show="
              this.$store.state.domainSystemX == 2 &&
              hasPublishedCompany == false &&
              companiesListDone == true
            "
            class="mt-2 text-center alert alert-danger"
          >
            <i class="fa fa-info-circle"></i>
            {{
              this.$store.getters.getWordLocale("txt_yayinda_firmaniz_olmali")
            }}
          </div>

          <div class="mt-2" v-show="gettingUserCompanies">
            <div class="alert alert-warning text-center">
              <i class="fa fa-spinner fa-spin fa-2x"></i>
            </div>
          </div>

          <div
            v-show="userCompanies.length > 0"
            class="
              d-xl-flex d-lg-flex d-md-flex
              row
              ml-0
              p-0
              select-company-item
              text-dark
            "
            v-for="(company, ci) in userCompanies"
            :key="ci"
          >
            <div class="col-xl-4 col-sm-4 select-company-buy-authorized">
              <strong>
                {{ company.name }}
              </strong>
            </div>

            <div class="col-xl-2 col-sm-2">
              <div class="select-company-buy-credit">
                <p class="credit-info">
                  <img
                    src="https://testcdn.forie.com/storage/images/general/coin.png"
                  />{{ company.totalCredit }}
                </p>
              </div>
            </div>

            <div class="col-xl-2 col-sm-2 mt-2">
              <span v-show="company.isBanned" class="badge bg-danger">
                <i class="fa fa-info-circle"></i>
                {{ this.$store.getters.getWordLocale("txt_banlandi") }}</span
              >
            </div>

            <div
              v-show="
                company.userHasPermissionToBuyLead &&
                company.totalCredit >= company.creditToSpend &&
                company.totalCredit > 0 &&
                credit > 0
              "
              class="col-4 col-sm-4 col-12 company-info mt-1 text-center"
            >
              <span class="new-credit-info"
                ><img
                  src="https://testcdn.forie.com/storage/images/general/coin.png"
                />{{ company.creditToSpend }}
              </span>
              <button
                class="btn select-company-lead-button"
                :disabled="company.isBanned"
                v-on:click="selectCompanyToBuyLead(company.companyId)"
              >
                {{ this.$store.getters.getWordLocale("txt_satin_al") }}
                <span v-show="company.companyId == selectedCompanyId"
                  ><i class="fa fa-spinner fa-spin"></i
                ></span>
              </button>
            </div>

            <div
              v-show="
                credit == 0 &&
                this.$store.state.domainSystemX == 2 &&
                hasPublishedCompany == true &&
                company.isPublished == true
              "
              class="col-4 col-sm-4 col-12 company-info mt-1 text-center"
            >
              <span class="free-lead-remaning" title=""
                >{{ this.$store.getters.getWordLocale("txt_kalan_hakki") }}:
                <b style=""
                  >{{ company.remaningViewCount }}/{{
                    company.viewRightCount
                  }}</b
                >
                <a
                  class="company-info-tooltip-box"
                  :title="
                    this.$store.getters.getWordLocale('txt_limit_gosterme')
                  "
                  ><i class="fas fa-info"></i
                ></a>
              </span>
              <button
                v-on:click="selectCompanyToViewLead(company.companyId)"
                v-show="company.remaningViewCount != 0"
                class="btn select-company-lead-button"
                :disabled="company.isBanned"
              >
                <i class="fas fa-eye"></i>
                {{ this.$store.getters.getWordLocale("txt_goster") }}
                <span v-show="company.companyId == selectedCompanyId"
                  ><i class="fa fa-spinner fa-spin"></i
                ></span>
              </button>
            </div>
          </div>
        </div>

        <div class="row" v-show="canViewLead == false && notFound == true">
          <div class="alert alert-danger text-center">
            <i class="fa fa-info-circle"></i>
            {{
              this.$store.getters.getWordLocale(
                "txt_islem_sirasinda_hata_olustu"
              )
            }}
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-6">
        <div class="card bg-dark text-white">
          <div class="card-header">
            <b>{{
              this.$store.getters.getWordLocale("txt_anahtar_kelimeleri")
            }}</b>
          </div>
          <div class="card-body" style="min-height: 95px">
            <div class="lead-keywords">
              <span v-for="(keyword, i) in leadKeywords" :key="i">
                {{ keyword }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="card bg-dark text-white">
          <div class="card-header">
            <b>{{ this.$store.getters.getWordLocale("txt_kategorileri") }}</b>
          </div>
          <div class="card-body" style="min-height: 95px">
            <div class="lead-keywords">
              <span v-for="(category, i) in leadCategoriesData" :key="i">
                {{ category.categoryName }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helper from "./helper.js";
import CountryFlag from "vue-country-flag-next";
import { mapState } from "vuex";
import moment from "moment";
import ForieLoader from "../shared/ForieLoader.vue";
import TeLoader from "../shared/TeLoader.vue";

export default {
  computed: mapState({
    langCodeX: (state) => state.langCodeX,
  }),
  watch: {
    langCodeX() {
      this.showLoader = true;
      this.reBuildLeadDetails();
      setTimeout(() => {
        this.showLoader = false;
      }, 100);
    },
  },
  data() {
    return {
      showLoader: true,
      selectedCompanyId: 0,
      companiesListDone: false,
      hasPublishedCompany: false,
      viewCount: 0,
      leadDocuments: [],
      isLeadBought: false,
      isLeadInBulletin: false,
      gettingUserCompanies: false,
      userCompanies: [],
      notFound: false,
      isLoadingDone: false,
      leadMessage: "",
      nameSurname: "",
      companyName: "",
      address: "",
      fax: "",
      email: "",
      country: "",
      webAddress: "",
      phone: "",
      canViewLead: false,
      leadDetailsFullData: [],
      leadCategories: [],
      leadCategoriesData: [],
      createTime: "",
      countryName: "",
      countryCode: "",
      loadDone: false,
      type: null,
      credit: null,
      leadSummary: "",
      leadTitle: "",
      leadId: 0,
    };
  },
  components: {
    ForieLoader,
    TeLoader,
    CountryFlag,
  },
  methods: {
    toSeoFormat(text) {
      try {
        text = text
          .replace("[DomainName]", this.domainName)
          .replace("[LeadTitle]", this.leadTitle)
          .replace("[RandomLeadTitle]", this.leadTitle)
          .replace(
            "[LeadKeywords]",
            this.leadKeywords.length > 0 ? this.leadKeywords.join(",") : ""
          )
          .replace(
            "[RandomLeadKeywords:1]",
            this.leadKeywords.length > 0 ? this.leadKeywords[0] : ""
          )
          .replace(
            "[RandomLeadKeywords:5]",
            this.leadKeywords.length > 0
              ? this.leadKeywords.slice(0, 5).join(",")
              : ""
          )
          .replace("[Country]", this.countryName)
          .replace("[LeadCategory]", "")
          .replace("[RandomLeadCategory:1]", "")
          .replace("[RandomLeadCategory:2]", "")
          .replace("[CompanyName]", "")
          .replace("[RandomCompanyName]", "")
          .replace("[CompanyDescription]", "")
          .replace("[RandomDescription]", "")
          .replace("[CompanyKeywords]", "")
          .replace("[ProductName]", "")
          .replace("[Category]", "")
          .replace("[SubCategory]", "")
          .replace("[RandomCategory:1]", "")
          .replace("[RandomCategory:2]", "");

        return text;
      } catch (error) {
        return text;
      }
    },
    async getLead() {
      this.showLoader = true;

      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getLead`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            leadId: parseInt(this.leadId),
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (this.leadDetails = data))
        .catch((err) => console.log(err.message));

      this.leadDetailsFullData = this.leadDetails;
      if (this.leadDetails == null) {
        window.location.href = `/${this.$store.state.langCodeX}/not-found`;
      }

      this.leadTitle =
        this.leadDetails.Localizations.filter(
          (q) => q.LangCode == this.$store.state.langCodeX
        ).length > 0
          ? this.leadDetails.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].Title
          : this.leadDetails.Localizations.filter(
              (q) => q.LangCode != this.$store.state.langCodeX
            )[0].Title;

      this.leadSummary =
        this.leadDetails.Localizations.filter(
          (q) => q.LangCode == this.$store.state.langCodeX
        ).length > 0
          ? this.leadDetails.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].ShortDescription
          : this.leadDetails.Localizations.filter(
              (q) => q.LangCode != this.$store.state.langCodeX
            )[0].ShortDescription;

      this.leadKeywords =
        this.leadDetailsFullData.Localizations.filter(
          (q) => q.LangCode == this.$store.state.langCodeX
        ).length > 0
          ? this.leadDetailsFullData.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].Keywords
          : this.leadDetailsFullData.Localizations.filter(
              (q) => q.LangCode != this.$store.state.langCodeX
            )[0].Keywords;
      this.leadKeywords =
        this.leadKeywords != null ? this.leadKeywords.split(",") : [];
      this.type = parseInt(this.leadDetails.Type);
      this.credit = parseInt(this.leadDetails.Credit);

      this.countryName =
        this.leadDetails.Country.filter(
          (q) => q.LangCode == this.$store.state.langCodeX
        ).length == 0
          ? this.leadDetails.Country.filter((q) => q.LangCode == "en").length ==
            0
            ? this.leadDetails.Country.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name
            : this.leadDetails.Country.filter((q) => q.LangCode == "en")[0].Name
          : this.leadDetails.Country.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].Name;

      this.countryCode =
        this.leadDetails.Country[0] != null &&
        this.leadDetails.Country[0] != undefined
          ? this.leadDetails.Country[0].Icon
          : "";

      const dateObject = new Date(
        this.leadDetails.PublishTime
      );

      this.leadDetails.Categories.forEach((element) => {
        var categoryId = parseInt(element.SubCategoryId);
        this.leadCategories.push(categoryId);
      });

      if (this.leadCategories.length > 0) {
        this.getSubCategoryNames();
      }

      this.createTime = dateObject.toLocaleString("tr-TR");

      var endDate = moment(new Date()).format("DD.MM.YYYY HH:mm:ss");
      endDate = moment(endDate, "DD.MM.YYYY HH:mm:ss");
      this.createTime = moment(this.createTime, "DD.MM.YYYY HH:mm:ss");

      var diff = endDate.diff(this.createTime, "days");
      if (diff == 0) {
        this.createTime = moment(
          this.createTime,
          "DD.MM.YYYY HH:mm:ss"
        ).fromNow();
      } else {
        this.createTime = dateObject.toLocaleString("tr-TR");
      }

      this.proccssSeoSettings();
      this.loadDone = true;
    },
    async getSubCategoryNames() {
      var leadCategoriesList = [];
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getSubCategoryNames`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            categoryIdList: this.leadCategories,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (leadCategoriesList = data))
        .catch((err) => console.log(err.message));

      if (leadCategoriesList != undefined && leadCategoriesList.length > 0) {
        leadCategoriesList.forEach((element) => {
          var leadId = parseInt(element._id);
          var categoryName =
            element.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            ).length > 0
              ? element.Localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                )[0].Name
              : element.Localizations.filter(
                  (q) => q.LangCode != this.$store.state.langCodeX
                )[0].Name;

          var slug =
            element.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            ).length > 0
              ? element.Localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                )[0].Slug
              : element.Localizations.filter(
                  (q) => q.LangCode != this.$store.state.langCodeX
                )[0].Slug;

          this.leadCategoriesData.push({
            id: leadId,
            categoryName: categoryName,
            slug: slug,
          });
        });
      }
    },
    reBuildLeadDetails() {
      this.leadTitle =
        this.leadDetailsFullData.Localizations.filter(
          (q) => q.LangCode == this.$store.state.langCodeX
        ).length > 0
          ? this.leadDetailsFullData.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].Title
          : this.leadDetailsFullData.Localizations.filter(
              (q) => q.LangCode != this.$store.state.langCodeX
            )[0].Title;

      this.leadSummary =
        this.leadDetailsFullData.Localizations.filter(
          (q) => q.LangCode == this.$store.state.langCodeX
        ).length > 0
          ? this.leadDetailsFullData.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].ShortDescription
          : this.leadDetailsFullData.Localizations.filter(
              (q) => q.LangCode != this.$store.state.langCodeX
            )[0].ShortDescription;

      this.proccssSeoSettings();

      this.countryName =
        this.leadDetailsFullData.Country.filter(
          (q) => q.LangCode == this.$store.state.langCodeX
        ).length == 0
          ? this.leadDetailsFullData.Country.filter((q) => q.LangCode == "en")
              .length == 0
            ? this.leadDetailsFullData.Country.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name
            : this.leadDetailsFullData.Country.filter(
                (q) => q.LangCode == "en"
              )[0].Name
          : this.leadDetailsFullData.Country.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].Name;
    },
    proccssSeoSettings() {
      this.$store.state.detailsKeywordsX = "";

      if (this.$store.state.leadDetailsTitleX == "") {
        this.$store.state.detailsTitleX = this.leadTitle;
      } else {
        this.$store.state.detailsTitleX = this.toSeoFormat(
          this.$store.state.leadDetailsTitleX
        );
      }

      if (this.$store.state.leadDetailsDescriptionX == "") {
        this.$store.state.detailsDescriptionX = this.leadSummary;
      } else {
        this.$store.state.detailsDescriptionX = this.toSeoFormat(
          this.$store.state.leadDetailsDescriptionX
        );
      }

      if (this.$store.state.leadDetailsKeywordsX == "") {
        this.$store.state.detailsKeywordsX = this.leadKeywords;
      } else {
        var temp = [];
        var isArray = Array.isArray(this.$store.state.leadDetailsKeywordsX);
        if (
          this.$store.state.leadDetailsKeywordsX.length > 0 &&
          isArray == true
        ) {
          this.$store.state.leadDetailsKeywordsX.forEach((element) => {
            var text = element.text;
            temp.push(text);
          });
          this.$store.state.detailsKeywordsX = temp;
        } else {
          this.$store.state.detailsKeywordsX = this.toSeoFormat(
            this.$store.state.leadDetailsKeywordsX
          );
        }
      }
    },
    async getLeadDetails(fromBuy) {
      var accessToken = helper.getCookie("fn_access_token");
      var result = [];
      await fetch(
        `${this.$store.state.apiUrlX}/api/v2/Lead/getLead?leadId=${this.leadId}&displayLang=${this.$store.state.langCodeX}&systemId=${this.$store.state.domainSystemX}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Public-WebAccessToken": this.$store.state.publicAccessTokenX,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
        .then((res) => res.json())
        .then((data) => (result = data))
        .catch((err) => console.log(err.message));

      this.showLoader = false;
      this.isLoadingDone = true;
      if (result != "") {
        if (result.resultText == "Success") {
          this.viewCount = result.responseObject.lead.viewCount;

          if (
            result.responseObject.company != [] &&
            result.responseObject.company != undefined &&
            result.responseObject.company != null
          ) {
            this.isLeadBought = result.responseObject.lead.isPurchased;
            if (this.isLeadBought == false) {
              this.isLeadInBulletin = result.responseObject.lead.sendAsBulletin;
            }

            this.leadMessage = result.responseObject.lead.description;
            this.nameSurname = result.responseObject.company.userName ?? "-";
            this.companyName = result.responseObject.company.name ?? "-";
            this.address = result.responseObject.company.address ?? "-";

            this.fax = result.responseObject.company.fax ?? "-";
            this.email = result.responseObject.company.email ?? "-";
            this.country = result.responseObject.company.countryName ?? "-";
            this.webAddress = result.responseObject.company.webSite ?? "-";
            this.phone = result.responseObject.company.phone ?? "-";

            this.leadDocuments = [];
            if (
              result.responseObject.documents != undefined &&
              result.responseObject.documents != null
            ) {
              result.responseObject.documents.forEach((element) => {
                var file = element.file;
                var arr = element.file.split("/");
                var name = arr[arr.length - 1];
                this.leadDocuments.push({ file: file, name: name });
              });
            }

            this.canViewLead = true;
            this.selectedCompanyId = 0;

            if (fromBuy) {
              this.$swal({
                position: "top-end",
                icon: "success",
                title: `${this.$store.getters.getWordLocale(
                  "txt_talep_satin_alindi"
                )}`,
                showConfirmButton: false,
                toast: true,
                timer: 3000,
              });
            }
          } else {
            this.canViewLead = false;
            this.getUserCompanies();
          }
        } else {
          this.canViewLead = false;
          this.notFound = true;
        }
      }
    },
    async getUserCompanies() {
      var accessToken = helper.getCookie("fn_access_token");
      var result = [];
      this.gettingUserCompanies = true;

      await fetch(
        `${this.$store.state.apiUrlX}/api/v2/Lead/getMyCompaniesToBuyLead?leadId=${this.leadId}&lang=${this.$store.state.langCodeX}&systemId=${this.$store.state.domainSystemX}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Public-WebAccessToken": this.$store.state.publicAccessTokenX,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
        .then((res) => res.json())
        .then((data) => (result = data))
        .catch((err) => console.log(err.message));

      this.gettingUserCompanies = false;
      if (result != "") {
        if (result.resultText == "Success") {
          if (result.responseObject.length > 0) {
            this.userCompanies = [];
            result.responseObject.forEach((element) => {
              var companyId = element.id;
              var name = element.name;
              var creditToSpend = element.creditToSpend;
              var totalCredit = element.totalCredit;
              var userHasPermissionToBuyLead =
                element.userHasPermissionToBuyLead;
              var outOfCategory = element.outOfCategory;

              if (this.$store.state.domainSystemX == 2) {
                if (element.isPublished) {
                  this.hasPublishedCompany = true;
                }
              }

              this.userCompanies.push({
                companyId: companyId,
                name: name,
                creditToSpend: creditToSpend,
                totalCredit: totalCredit,
                userHasPermissionToBuyLead: userHasPermissionToBuyLead,
                outOfCategory: outOfCategory,
                remaningViewCount: element.viewedFreeLeadsCount,
                viewRightCount: element.readFreeLeadsCount,
                isPublished: element.isPublished,
                isBanned: element.isBanned,
              });
            });

            this.companiesListDone = true;
          }
        } else {
          console.log(result);
        }
      }
    },
    async selectCompanyToBuyLead(companyId) {
      var companyInfo = this.userCompanies.filter(
        (q) => q.companyId == companyId
      )[0];
      if (companyInfo.outOfCategory == true) {
        this.$swal({
          title: `${this.$store.getters.getWordLocale("txt_uyari")}`,
          html: `${this.$store.getters.getWordLocale(
            "txt_uyari_farkli_kategori_talep"
          )}`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: `${this.$store.getters.getWordLocale("txt_hayir")}`,
          confirmButtonText: `${this.$store.getters.getWordLocale("txt_evet")}`,
        }).then((result) => {
          if (result.isConfirmed) {
            this.buyLead(companyId);
          }
        });
      } else {
        this.buyLead(companyId);
      }
    },
    async buyLead(companyId) {
      if (this.selectedCompanyId != 0) {
        return;
      }

      this.selectedCompanyId = companyId;
      var result = [];
      var accessToken = helper.getCookie("fn_access_token");

      await fetch(
        `${this.$store.state.apiUrlX}/api/v2/Lead/BuyLead?leadId=${this.leadId}&lang=${this.$store.state.langCodeX}&companyIdToBuy=${companyId}`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Public-WebAccessToken": this.$store.state.publicAccessTokenX,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
        .then((res) => res.json())
        .then((data) => (result = data))
        .catch((err) => console.log(err.message));

      if (result.resultText == "Success") {
        this.getLeadDetails(true);
      } else {
        this.selectedCompanyId = 0;

        this.$swal({
          position: "top-end",
          icon: "warning",
          text: result.message,
          showConfirmButton: false,
          toast: true,
          timer: 3000,
        });
      }
    },

    async selectCompanyToViewLead(companyId) {
      this.viewLead(companyId);
    },
    async viewLead(companyId) {
      if (this.selectedCompanyId != 0) {
        return;
      }

      this.selectedCompanyId = companyId;
      var result = [];
      var accessToken = helper.getCookie("fn_access_token");

      await fetch(
        `${this.$store.state.apiUrlX}/api/v2/Lead/ViewLead?leadId=${this.leadId}&lang=${this.$store.state.langCodeX}&companyIdToBuy=${companyId}`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Public-WebAccessToken": this.$store.state.publicAccessTokenX,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
        .then((res) => res.json())
        .then((data) => (result = data))
        .catch((err) => console.log(err.message));

      if (result.resultText == "Success") {
        this.getLeadDetails(true);
      } else {
        this.selectedCompanyId = 0;
        this.$swal({
          position: "top-end",
          icon: "warning",
          text: result.message,
          showConfirmButton: false,
          toast: true,
          timer: 3000,
        });
      }
    },
  },
  created() {
    moment.locale(`${this.$store.state.langCodeX}`);

    this.leadId = helper.getCompanyId(this.$route.params.id);
    this.getLead();

    if (this.$store.state.userLoggedInX) {
      this.getLeadDetails(false);
    } else {
      this.showLoader = false;
      this.isLoadingDone = true;
    }
  },
};
</script>

<style scoped>
.company-country small {
  margin-top: 10px;
  margin-left: 4px;
  font-weight: 900;
  font-size: 12px;
}

.is-company-vip small {
  margin-top: 9px;
  margin-left: 4px;
  font-weight: 900;
  font-size: 12px;
}

.is-company-vip {
  margin-top: 9px;
  margin-left: 6px;
}

.separator {
  margin-top: 7px;
  margin-left: 7px;
}

.read-more {
  cursor: pointer;
}

.sell {
  color: #34c5f3 !important;
  border: 1px solid #34c5f3 !important;
  margin-right: 3px;
  font-size: 12px;
  padding: 6px 10px;
}

.buy {
  color: #e71d36 !important;
  border: 1px solid #e71d36 !important;
  font-size: 12px;
  margin-right: 3px;
  padding: 6px 10px;
}

.not-free {
  min-width: 50px;
  text-align: center;
  margin-top: 5px;
  color: #daa520 !important;
  border: 1px solid #daa520 !important;
  font-size: 12px;
  margin-right: 3px;
  padding: 6px 10px;
  height: 31px;
}

.free {
  min-width: 50px;
  text-align: center;
  margin-top: 5px;
  color: #16a448 !important;
  border: 1px solid #16a448 !important;
  font-size: 12px;
  margin-right: 3px;
  padding: 6px 10px;
  height: 31px;
}

.lead-country small {
  margin-top: 9px;
  margin-left: 4px;
  font-weight: 900;
}

.lead-time {
  font-size: 12px;
  font-weight: 700;
  color: #707070;
}

.contact-details span {
  width: 49%;
  display: inline-flex;
  margin: 2px 0;
}

.contact-details > span > b {
  color: #d2e2fb;
  font-weight: 500;
  width: 35%;
  display: inline-block;
  min-width: 137px;
}

.contact-details > span > span {
  color: #ffffff;
  margin-left: 5px;
  max-width: 299px;
}

.lead-keywords {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  max-height: 62px;
  overflow: hidden;
}

.lead-keywords span {
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  border-radius: 2px;
  border: solid 1px #dfe5ee;
  height: 26px;
  align-items: center;
  justify-content: center;
  padding: 0 9px;
  margin-top: 5px;
  margin-right: 5px;
  font-size: 12px;
}

.buy-lead-info {
  text-align: center;
}

.buy-lead-info small {
  padding: 17px;
  background-color: #daa520;
  border-radius: 50px;
  display: inline-block;
}

.select-company-to-proceed > h3 {
  font-size: 16px;
  color: #fff;
  margin: 0 !important;
}

.select-company-to-proceed > h4 {
  font-size: 15px;
  color: #fff;
  margin-bottom: 10px;
}

.auth-companies-title {
  display: block;
  text-align: center;
  font-size: 12px;
  color: #00245d;
  margin-top: 10px;
  background-color: #eef4fd;
  padding: 8px 2px;
  border: 1px solid #d0e3ff;
}

.select-company-item {
  min-height: 80px;
  background-color: #eef4fd;
  border: 1px solid #d0e3ff;
  padding: 20px !important;
  margin: 10px 0 10px 0;
}

.select-company-buy-credit {
  padding: 8px 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: 65px;
}

.select-company-buy-credit > p {
  margin: 0;
}

.select-company-buy-credit > p > img {
  width: 16px;
  margin-right: 5px;
  vertical-align: text-top;
}

.select-company-buy-authorized {
  padding: 8px 0;
}

.select-company-item .company-info .new-credit-info {
  font-size: 12px;
  background-color: #2e972b;
  color: #fff;
  padding: 13px 8px;
  margin-top: 0px;
  vertical-align: middle;
  border-radius: 4px 0px 0px 4px;
}

.select-company-item .company-info .new-credit-info > img {
  width: 16px;
  margin-right: 5px;
}

.select-company-item .company-info .select-company-lead-button {
  background-color: #2fa92c;
  color: #fff;
  padding: 10px 12px;
  border-radius: 0;
  border-radius: 0px 4px 4px 0px;
  font-size: 12px;
}

.bought-badge {
  font-size: 12px;
  font-family: "DM Sans";
  padding: 5px 15px;
  border-radius: 8px;
  display: inline-block;
  font-weight: 900;
  color: #17a2b8;
  border: 1px solid #17a2b8;
}

.country-flag {
  width: 54px !important;
  margin-top: -7px !important;
}

.select-company-item .company-info .free-lead-remaning {
  font-size: 12px;
  background-color: #fff;
  color: #b0b8c5;
  padding: 11px 15px;
  border: 1px solid #dfe5ee;
  display: flex;
  vertical-align: middle;
  align-items: center;
}

.select-company-item .company-info .free-lead-remaning > b {
  color: #000;
  margin-left: 5px;
}

.company-info-tooltip-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 6px;
}

.company-info-tooltip-box svg {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #34c5f3;
  border: 1px solid #34c5f3;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  font-size: 10px;
  padding: 3px;
}

.select-company-item .company-info {
  text-align: center !important;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0;
  flex-wrap: wrap;
}

.page-laoder {
  background: #ffffff96 !important;
}
</style>